module.exports = __webpack_public_path__ + "static/media/cash-grey.a4c0051e.svg";